type EnglishLocale = 'en-US' | 'en-GB';

export const getEnglishLocale = (languages: readonly string[]): EnglishLocale => {
	for (const language of languages) {
		const normalized = language.toLowerCase();
		if (normalized === 'en-gb' || normalized.startsWith('en-gb-')) {
			return 'en-GB';
		}
		if (normalized === 'en' || normalized === 'en-us' || normalized.startsWith('en-us-')) {
			return 'en-US';
		}
	}
	return 'en-US';
};

export const englishMessages: Record<EnglishLocale, Record<string, string>> = {
	'en-US': {},
	'en-GB': {
		'dtac.graphClawHub.myInference.utilisationTab.ai-non-final': 'Utilisation',
		'dtac.graphClawHub.utilisation.loaded.ai-non-final': 'Utilisation loaded.',
		'dtac.graphClawHub.utilisation.loading.ai-non-final': 'Loading utilisation',
		'dtac.graphClawHub.utilisation.error.ai-non-final': 'Could not load utilisation. Try again.',
		'dtac.graphClawHub.utilisation.empty.ai-non-final':
			'No utilisation data was reported for this app version and filter in the selected period.',
	},
};
